jQuery(document).ready(function($) {
  $('#categories').owlCarousel({
  dots: false,
  items: 6,
  loop: true,
  margin: 30,
  nav: true,
  responsive: {
    0: {
      items: 1, 
    },
 580: {
      items: 2, 
    },
    768: {
      items: 3
    },
    1000: {
      items: 3
    }
   
  },

});
});
$("#customPrev").click(function () {
$(".owl-carousel").trigger("prev.owl.carousel");
});

$("#customNext").click(function () {
$(".owl-carousel").trigger("next.owl.carousel");
});

$('#customer-say').owlCarousel({
 loop:true,
 margin:30,
 nav:true,
  dots:false,
 responsive:{
     0:{
         items:1
     },
     600:{
         items:3
     },
     1000:{
         items:3
     }
 }
})

$(document).ready(function() {
  // Show popup when the link is clicked
  $('.showPopup').click(function() {
    $('.popupBox').fadeIn(); // Use fadeIn for smooth visibility
  });

  // Hide popup when the close button is clicked
  $('.closePopup').click(function() {
    $('.popupBox').fadeOut(); // Use fadeOut for smooth disappearance
  });
});
